import React, { useState } from 'react';
import { Link as LinkIcon, MessageSquare, Mail, Instagram, Facebook, Linkedin, FileText } from 'lucide-react';
export function DashboardShare() {
  const displaySlug = 'marcuschen';
  const fullUrl = `eaves.pro/${displaySlug}`;
  const handleCopy = () => {
    navigator.clipboard.writeText(fullUrl);
    alert('Copied!');
  };
  return <div className="p-8 max-w-4xl mx-auto" data-id="element-779">
      <h1 className="text-3xl font-serif font-semibold text-brand-dark mb-8" data-id="element-780">
        Share your profile
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-10" data-id="element-781">
        {/* QR Code Card */}
        <div className="sm:col-span-2 bg-white border border-brand-light rounded-2xl shadow-sm p-6 text-center flex flex-col items-center" data-id="element-782">
          <div className="w-40 h-40 bg-white border border-brand-light rounded-xl flex items-center justify-center mb-4 relative" data-id="element-783">
            {/* Fake QR Code Pattern */}
            <div className="grid grid-cols-5 gap-1 w-32 h-32" data-id="element-784">
              {Array.from({
              length: 25
            }).map((_, i) => <div key={i} className={`rounded-sm bg-brand-forest ${i % 3 === 0 || i % 7 === 0 ? 'opacity-20' : ''}`} data-id="element-785"></div>)}
            </div>
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-786">
              <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-sm" data-id="element-787">
                <span className="font-serif font-bold text-brand-forest" data-id="element-788">
                  E
                </span>
              </div>
            </div>
          </div>
          <p className="font-mono text-sm text-brand-muted mb-4" data-id="element-789">{fullUrl}</p>
          <div className="flex gap-3 mb-2" data-id="element-790">
            <button onClick={() => alert('Downloaded ✓')} className="border border-brand-forest text-brand-forest rounded-xl px-4 py-2 text-sm font-medium hover:bg-brand-sage transition-colors" data-id="element-791">
              Download QR
            </button>
            <button onClick={() => alert('Sent to printer ✓')} className="border border-brand-forest text-brand-forest rounded-xl px-4 py-2 text-sm font-medium hover:bg-brand-sage transition-colors" data-id="element-792">
              Print
            </button>
          </div>
          <p className="text-xs text-brand-muted" data-id="element-793">
            Add to your business cards, open house flyers, and listing sheets
          </p>
        </div>

        <button onClick={handleCopy} className="bg-white border border-brand-light rounded-xl p-3 flex items-center gap-3 shadow-sm hover:border-brand-forest transition-colors" data-id="element-794">
          <div className="w-10 h-10 rounded-full bg-brand-sage flex items-center justify-center shrink-0" data-id="element-795">
            <LinkIcon size={18} className="text-brand-forest" data-id="element-796" />
          </div>
          <span className="font-medium text-brand-dark" data-id="element-797">Copy profile link</span>
        </button>

        <a href={`sms:?body=Check out my Eaves Pro profile: ${fullUrl}`} className="bg-white border border-brand-light rounded-xl p-3 flex items-center gap-3 shadow-sm hover:border-brand-forest transition-colors" data-id="element-798">
          <div className="w-10 h-10 rounded-full bg-brand-sage flex items-center justify-center shrink-0" data-id="element-799">
            <MessageSquare size={18} className="text-brand-forest" data-id="element-800" />
          </div>
          <span className="font-medium text-brand-dark" data-id="element-801">Send via text</span>
        </a>

        <a href={`mailto:?subject=My Eaves Pro Profile&body=Check out my profile: ${fullUrl}`} className="bg-white border border-brand-light rounded-xl p-3 flex items-center gap-3 shadow-sm hover:border-brand-forest transition-colors" data-id="element-802">
          <div className="w-10 h-10 rounded-full bg-brand-sage flex items-center justify-center shrink-0" data-id="element-803">
            <Mail size={18} className="text-brand-forest" data-id="element-804" />
          </div>
          <span className="font-medium text-brand-dark" data-id="element-805">Share via email</span>
        </a>

        <button onClick={() => {
        navigator.clipboard.writeText(fullUrl);
        alert('Link copied — paste it in your Instagram bio');
      }} className="bg-white border border-brand-light rounded-xl p-3 flex items-center gap-3 shadow-sm hover:border-brand-forest transition-colors" data-id="element-806">
          <div className="w-10 h-10 rounded-full bg-brand-sage flex items-center justify-center shrink-0" data-id="element-807">
            <Instagram size={18} className="text-brand-forest" data-id="element-808" />
          </div>
          <span className="font-medium text-brand-dark" data-id="element-809">
            Add to Instagram bio
          </span>
        </button>

        <a href="#" className="bg-white border border-brand-light rounded-xl p-3 flex items-center gap-3 shadow-sm hover:border-brand-forest transition-colors" data-id="element-810">
          <div className="w-10 h-10 rounded-full bg-brand-sage flex items-center justify-center shrink-0" data-id="element-811">
            <Facebook size={18} className="text-brand-forest" data-id="element-812" />
          </div>
          <span className="font-medium text-brand-dark" data-id="element-813">Share on Facebook</span>
        </a>

        <a href="#" className="bg-white border border-brand-light rounded-xl p-3 flex items-center gap-3 shadow-sm hover:border-brand-forest transition-colors" data-id="element-814">
          <div className="w-10 h-10 rounded-full bg-brand-sage flex items-center justify-center shrink-0" data-id="element-815">
            <Linkedin size={18} className="text-brand-forest" data-id="element-816" />
          </div>
          <span className="font-medium text-brand-dark" data-id="element-817">Share on LinkedIn</span>
        </a>
      </div>

      <h3 className="font-medium text-brand-dark mb-3" data-id="element-818">Ideas for your link</h3>
      <div className="space-y-3" data-id="element-819">
        <div className="flex items-center gap-3" data-id="element-820">
          <Mail size={16} className="text-brand-muted" data-id="element-821" />
          <span className="text-sm text-brand-muted" data-id="element-822">
            Add to your email signature
          </span>
        </div>
        <div className="flex items-center gap-3" data-id="element-823">
          <Instagram size={16} className="text-brand-muted" data-id="element-824" />
          <span className="text-sm text-brand-muted" data-id="element-825">
            Put it in your social media bios
          </span>
        </div>
        <div className="flex items-center gap-3" data-id="element-826">
          <FileText size={16} className="text-brand-muted" data-id="element-827" />
          <span className="text-sm text-brand-muted" data-id="element-828">
            Print it on business cards and open house flyers
          </span>
        </div>
      </div>
    </div>;
}